import React from 'react';
import { Card, CardBody, Heading, Image, Stack, IconButton, Box, Text } from '@chakra-ui/react';
import { FaApple, FaSpotify } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function BrowseArtistCard({ artist }) {
    const handlePlatformClick = (platform) => {
        if (platform.platform === "spotify") {
            window.open(`https://open.spotify.com/artist/${platform.id}`, '_blank');
        } else if (platform.platform === "apple") {
            window.open(`https://music.apple.com/us/artist/${platform.id}`, '_blank');
        }
    };

    const artistPlatforms = artist.artist_id || artist.account?.profile?.artist_id || [];

    return (
        <Card 
            as={Link} 
            to={`/artist/${artist.user_id}`} 
            maxW={{ base: "350px", md: "300px", lg: "320px" }}
            w={{ base: "100%", md: "280px", lg: "300px" }}
            h={{ base: "420px", md: "450px", lg: "470px" }}
            mx={{ base: "auto", sm: "0" }}
            scrollSnapAlign="start" 
            p={3} 
            bg="transparent" 
            boxShadow="lg" 
            border="2px" 
            borderColor="dark.500" 
            position="relative"
            _hover={{ transform: "translateY(-4px)", boxShadow: "xl" }}
            transition="all 0.3s ease"
        >
            <CardBody p={3} display="flex" flexDirection="column" h="100%">
                <Image
                    w="100%"
                    h={{ base: "180px", md: "200px", lg: "220px" }}
                    objectFit="cover"
                    src={artist.image_url || artist.account?.profile?.image_url}
                    alt={artist.artist_name || artist.account?.profile?.artist_name}
                    borderRadius="lg"
                    transition="transform 0.3s ease-in-out"
                    _hover={{ transform: "scale(1.05)" }}
                />
                <Stack mt="6" spacing="3" flex="1">
                    <Heading color="primary.900" noOfLines={1} size="sm">
                        {artist.artist_name || artist.account?.profile?.artist_name}
                    </Heading>
                    
                    {artistPlatforms.length > 0 && (
                        <Box>
                            <Text 
                                color="primary.900" 
                                fontSize={{ base: 'sm', md: 'md' }} 
                                fontWeight="semibold" 
                                mb={2}
                                textAlign="left"
                            >
                                Streaming on:
                            </Text>
                            <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
                                {artistPlatforms.map((platform, index) => (
                                    <IconButton
                                        key={index}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handlePlatformClick(platform);
                                        }}
                                        size="sm"
                                        variant="ghost"
                                        bg="secondary.900"
                                        icon={platform.platform === "spotify" ? <FaSpotify /> : platform.platform === "apple" ? <FaApple /> : null}
                                        aria-label={`Listen on ${platform.platform}`}
                                        _hover={{ 
                                            bg: "primary.900", 
                                            transform: "scale(1.1)" 
                                        }}
                                        transition="all 0.2s ease"
                                    />
                                ))}
                            </Box>
                        </Box>
                    )}
                </Stack>
            </CardBody>
        </Card>
    );
}